/**
 * Client-safe stub: no AsyncLocalStorage in the browser.
 * Used when bundling for the client (webpack alias from correlation.runtime).
 */

export const correlationStorage = {
  run<T>(_id: string, fn: () => T): T {
    return fn()
  },
  getStore(): string | undefined {
    return undefined
  }
}

export const getCorrelationId = (): string | undefined => undefined

export const generateCorrelationId = (): string => ''

export const runWithCorrelation = <T>(_correlationId: string, fn: () => T): T => fn()
